import axios from 'axios';
import { installSilentRefresh } from '@/lib/installSilentRefresh';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { 'X-Client-Platform': 'web' },
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('fender_admin_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

installSilentRefresh({
  api, accessKey: 'fender_admin_token', refreshKey: 'fender_admin_refresh', loginPath: '/login',
});

export function formatApiError(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

// ---- /api/v1 envelope helpers: unwrap { success, data, meta, error } ---- //

async function request(method, url, { body, params } = {}) {
  try {
    const { data } = await api.request({ method, url: `/v1${url}`, data: body, params });
    return { data: data?.data, meta: data?.meta || {} };
  } catch (e) {
    const env = e.response?.data;
    const msg = env?.error?.message || formatApiError(env?.detail) || e.message;
    const err = new Error(msg);
    err.code = env?.error?.code;
    err.fieldErrors = env?.error?.field_errors || {};
    throw err;
  }
}

export const getV1 = (url, params) => request('get', url, { params });
export const postV1 = (url, body, params) => request('post', url, { body, params });
export const patchV1 = (url, body) => request('patch', url, { body });
export const delV1 = (url) => request('delete', url);
export const delV1Body = (url, body) => request('delete', url, { body });
